import { render, staticRenderFns } from "./SingleImage3.vue?vue&type=template&id=2bbf3d0e&scoped=true"
import script from "./SingleImage3.vue?vue&type=script&lang=js"
export * from "./SingleImage3.vue?vue&type=script&lang=js"
import style0 from "./SingleImage3.vue?vue&type=style&index=0&id=2bbf3d0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf3d0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\moyongpeng-project\\tianyi-crm\\scrm-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbf3d0e')) {
      api.createRecord('2bbf3d0e', component.options)
    } else {
      api.reload('2bbf3d0e', component.options)
    }
    module.hot.accept("./SingleImage3.vue?vue&type=template&id=2bbf3d0e&scoped=true", function () {
      api.rerender('2bbf3d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/SingleImage3.vue"
export default component.exports